import React, { useState, useEffect, useContext } from 'react'

import { Dimensions, Platform, ScrollView, View, useWindowDimensions } from 'react-native'

import { VFScreen, VFText, VFBanner, QuickActionMenu, VFButton } from '@vfgroup-oneplatform/foundation/Components'

import Button from '../../Components/ButtonCard/index'
import OfferCard from '../../Components/OfferCard'
import ErrorHandlerComponent from '../../Components/ErrorHandler'


import styles from './Home.Styles'

import RoamingContext from '../../Context'
import { getThemeImages } from '../../Themes/Modes/Helpers'
import { isArray } from 'lodash'

import Modal from 'react-native-modal'
import InfoOverlay from '../../../../../App/Components/InfoOverlay/InfoOverlay'
import _Images from '../../../../../App/Themes/Images'


const LOADING_BUNDLES = [{}, {}, {}, {}]

const Home = () => {

  const { onClose,
    navigate,
    theme,
    userType,
    countriesList,
    setScreen: screenStateChange,
    setSearchType,
    // API CALLS
    getRoamingRecommendationOffer,
    getRoamingOfferBundles
    // getCountryFromCoordinates
  } = useContext(RoamingContext).roamingState

  const Images = getThemeImages(theme.name)

  const POSTPAID_TYPES = ['postpaid', 'postpaid_fix']

  const [countryOnLocation, setCountryOnLocation] = useState(null)

  const [recommandation, setRecommandation] = useState(null)
  const [recommandationError, setRecommandationError] = useState(false)
  const [recommandationLoading, setRecommandationLoading] = useState(true)
  const [showRecommandationMoreInfo, setShowRecommandationMoreInfo] = useState(false)

  const [bundles, setBundles] = useState(null)
  const [bundlesError, setBundlesError] = useState(false)
  const [bundlesLoading, setBundlesLoading] = useState(true)

  const { width } = useWindowDimensions()
  const [isModalVisible, setIsModalVisible] = useState(false)


  const getCountryFromLocation = async () => {
    // const result = await request(Platform.OS === 'ios'
    //   ? PERMISSIONS.IOS.LOCATION_WHEN_IN_USE
    //   : PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION)

    // if (result?.includes('granted')) {
    //   Geolocation.getCurrentPosition(
    //     success => {
    //       const { latitude, longitude } = success.coords
    //       // const response = getCountryFromCoordinates(latitude, longitude)
    //       // if (response) {
    //       //   const filteredCountry = countriesList.filter(country => {
    //       //     country.id === response
    //       //     return country
    //       //   })
    //       //   setSelectedcountry(filteredCountry[0])
    //       // }

    //       // Remove below lines when logic works as intended

    //       const filteredCountry = countriesList?.countriesAlb?.find(country => country?.id === 'UK') || {}
    //       setCountryOnLocation(filteredCountry)
    //     },
    //     error => {
    //       // do nothing as error means the user has not enable the location or has not given location permission yet
    //     }
    //   )
    // }
  }

  const getAndSetRecommandation = async () => {
    setRecommandationLoading(true)
    try {
      const res = await getRoamingRecommendationOffer(countryOnLocation?.name || null)
      if (res) {
        setRecommandation(res)
        setRecommandationError(false)
      }
    } catch (error) {
      setRecommandationError(true)
      console.log(error, 'error in recommandation')
    }
    finally {
      setRecommandationLoading(false)
    }
  }

  const getAndSetBundles = async () => {
    setBundlesLoading(true)
    try {
      const res = await getRoamingOfferBundles(countryOnLocation?.name || null)
      if (res) {
        setBundles(res)
        setBundlesError(false)
      } else {
        setBundlesError(true)
      }
    }
    catch (error) {
      setBundlesError(true)
    } finally {
      setBundlesLoading(false)
    }
  }

  const changeSearchTypeAndFetch = (type) => {
    let searchTypeParam = null
    setSearchType(type)
    if (userType?.includes(POSTPAID_TYPES)) {
      type === 'prepaid' ? searchTypeParam = 'prepaid' : null
    } else {
      type === 'postpaid' ? searchTypeParam = 'postpaid' : null
    }
    setRecommandation(null)
    getAndSetRecommandation(countryOnLocation, searchTypeParam)
  }

  useEffect(() => {
    // getCountryFromLocation()
    getAndSetRecommandation()
    if (!userType.includes(POSTPAID_TYPES)) {
      getAndSetBundles()
    }
  }, [])

  const roamingSteps = [
    'roaming_settings_roaming_step_one_android',
    'roaming_settings_roaming_step_two_android',
    'roaming_settings_roaming_step_three_android',
    'roaming_settings_roaming_step_four_android'
  ]

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen
        title={'roaming_screen_title'}
        onClose={onClose}
      >
        <ScrollView contentContainerStyle={{ paddingHorizontal: '10%', paddingBottom: '10%' }}>
          <View style={styles.scrollView}>
            {/* Settings banner */}
            <VFBanner
              title={'roaming_settings_title'}
              titleStyle={styles.bannerTitle}
              description={'roaming_settings_description'}
              descriptionStyle={styles.bannerDescription}
              withCloseButton={false}
              withLeftIcon={true}
              leftIconType={'image'}
              leftIcon={Images.roaming}
              leftIconSize={25}
              primaryButtonTitle={'roaming_settings_title'}
              primaryButtonViewStyle={styles.bannerButtonStyle(theme)}
              textPrimaryButtonStyle={styles.bannerButtonTitleStyle(theme)}
              containerViewStyle={styles.marginHorizontal0}
              backgroundColors={['rgba(0, 124, 146, 1)', 'rgba(0, 124, 146, 1)']}
              onPrimaryButtonPress={() => {
                navigate('RoamingSettings')
              }}
            />

            {/* Where to Section */}
            <VFText i18nKey={'roaming_where_to'} style={styles.boldTitle(theme)} />
            <VFText
              i18nKey={'roaming_where_to_description'}
              style={styles.graySubtitle(theme)}
            />
            {/*  TODO: All the comments to be uncommented in phase 2 */}
            {/* <SelectionList
            containerStyle={styles.selectionListContainer}
            itemContainerStyle={styles.selectionListItem(theme)}
            activeContainerStyle={styles.selectionListActiveItem}
            options={[{ title: 'romaing_select_prepaid'}, { tittle: 'romaing_select_postpaid'} ]}
            initialSelectedIndex={POSTPAID_TYPES.includes(userType) ? 1 : 0}
            onSelectOption={(index) => {
              // When user type is the same as the selected option then set the search type to null as with null we get the info for MSISDN
              if (index === 1) {
                changeSearchTypeAndFetch('postpaid')
              } else {
                changeSearchTypeAndFetch('prepaid')
              }
  
            }}
            theme={theme}
            withInitialScrollToIndex={false}
            itemWidth={(width - 32) / 2}
          /> */}

            <Button
              style={styles.searchButton}
              title={'roaming_select_destination'}
              icon={Images.airplane}
              directionIcon={Images.rightArrowRed}
              onPress={() => screenStateChange({ screen: 'SEARCHING', props: {} })}
              theme={theme}
            />

            {/* Recommandation Offer Card */}
            <>
              {/* TODO: TO be deleted */}
              {/* {recommandationLoading && <ContentLoader
              width={width}
              height={80}
              backgroundColor={'#820000d3'}
              foregroundColor={'#E60000c3'}
              viewBox={`0 0 ${width} ${80}`}
            >
              <Rect x="0" y="0" rx="5" ry="5" width={width - 32} height={80} />
            </ContentLoader>} */}
              {recommandationError && <ErrorHandlerComponent
                textButton={'roaming_get_recommandation_error'}
                onRetry={() => getAndSetRecommandation(countryOnLocation?.name || null)}
              />}
              {!recommandationError && <OfferCard
                title={recommandation?.title}
                description={recommandation?.description}
                image={countryOnLocation?.image}
                withButton={false}
                recommandationLoading={recommandationLoading}
                buttonTitle={recommandation?.CTATitle}
                onPress={() => {
                  if (recommandation?.CTAType?.includes('webview')) {
                    navigate('WebView', { url: recommandation?.CTAUrl, title: recommandation?.title, isReact: true })
                  }
                  else if (recommandation?.CTAType?.includes('deeplink')) {
                    navigate('Catalogue', { bundleId: recommandation?.myOfferId })
                  }
                  else {
                    setShowRecommandationMoreInfo(true)
                  }
                }}
                theme={theme}
              />}

              <QuickActionMenu isVisible={showRecommandationMoreInfo} title={'roaming_more_info'} titleStyle={{ fontSize: 24, marginHorizontal: -15 }} withCloseButton type={'secondary'} closeModal={() => setShowRecommandationMoreInfo(false)} >
                <VFText i18nKey={recommandation?.longDesc} style={{ fontSize: 18, lineHeight: 24, marginVertical: 20 }} />
                <VFButton title='roaming_close' onPress={() => setShowRecommandationMoreInfo(false)} />
              </QuickActionMenu>
            </>

            {/* Suggested Bundles */}
            {bundles?.length > 0 && < VFText i18nKey={'roaming_bundles_title'} style={styles.boldTitle(theme)} />}
            {bundlesLoading && <View style={{ marginTop: 20 }}>
              {LOADING_BUNDLES.map(() => <Button bundlesLoading={true} />)}
            </View>}
            {bundlesError && <ErrorHandlerComponent
              textButton={'roaming_bundles_default_error'}
              onRetry={() => getAndSetBundles(countryOnLocation?.name || null)}
            />}
            {isArray(bundles) && bundles?.map(bundle => {
              return (
                <Button
                  bundlesLoading={false}
                  title={bundle?.title}
                  price={bundle?.price}
                  icon={Images.airplane}
                  directionIcon={Images.rightArrowRed}
                  onPress={() => navigate('Catalogue', {
                    bundleCategory: 'roaming',
                    bundleId: bundle.id
                  })}
                  theme={theme}
                />
              )
            })}
          </View>
        </ScrollView>
        <Modal
          isVisible={isModalVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => setIsModalVisible(prev => !prev)}
          onBackdropPress={() => setIsModalVisible(prev => !prev)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <InfoOverlay
              containerStyle={{ marginTop: 0 }}
              icon={_Images.ic_roaming_location}
              description={
                'roaming_settings_locationPermission_steps_description'
              }
              steps={roamingSteps}
              onPress={() => {
                setIsModalVisible(prev => !prev)
              }}
              iconSize={64}
              withButton={true}
            />
          </View>
        </Modal>
      </VFScreen>
    )
  }


  return (
    <VFScreen title={'roaming_screen_title'} onClose={onClose}>
      <ScrollView>
        <View style={styles.scrollView}>
          {/* Settings banner */}
          <VFBanner
            title={'roaming_settings_title'}
            titleStyle={styles.bannerTitle}
            description={'roaming_settings_description'}
            descriptionStyle={styles.bannerDescription}
            withCloseButton={false}
            withLeftIcon={true}
            leftIconType={'image'}
            leftIcon={Images.roaming}
            leftIconSize={25}
            primaryButtonTitle={'roaming_settings_title'}
            primaryButtonViewStyle={styles.bannerButtonStyle(theme)}
            textPrimaryButtonStyle={styles.bannerButtonTitleStyle(theme)}
            containerViewStyle={styles.marginHorizontal0}
            backgroundColors={['rgba(0, 124, 146, 1)', 'rgba(0, 124, 146, 1)']}
            onPrimaryButtonPress={() => {
              navigate('RoamingSettings')
            }}
          />

          {/* Where to Section */}
          <VFText i18nKey={'roaming_where_to'} style={styles.boldTitle(theme)} />
          <VFText
            i18nKey={'roaming_where_to_description'}
            style={styles.graySubtitle(theme)}
          />
          {/*  TODO: All the comments to be uncommented in phase 2 */}
          {/* <SelectionList
          containerStyle={styles.selectionListContainer}
          itemContainerStyle={styles.selectionListItem(theme)}
          activeContainerStyle={styles.selectionListActiveItem}
          options={[{ title: 'romaing_select_prepaid'}, { tittle: 'romaing_select_postpaid'} ]}
          initialSelectedIndex={POSTPAID_TYPES.includes(userType) ? 1 : 0}
          onSelectOption={(index) => {
            // When user type is the same as the selected option then set the search type to null as with null we get the info for MSISDN
            if (index === 1) {
              changeSearchTypeAndFetch('postpaid')
            } else {
              changeSearchTypeAndFetch('prepaid')
            }

          }}
          theme={theme}
          withInitialScrollToIndex={false}
          itemWidth={(width - 32) / 2}
        /> */}

          <Button
            style={styles.searchButton}
            title={'roaming_select_destination'}
            icon={Images.airplane}
            directionIcon={Images.rightArrowRed}
            onPress={() => screenStateChange({ screen: 'SEARCHING', props: {} })}
            theme={theme}
          />

          {/* Recommandation Offer Card */}
          <>
            {/* TODO: TO be deleted */}
            {/* {recommandationLoading && <ContentLoader
            width={width}
            height={80}
            backgroundColor={'#820000d3'}
            foregroundColor={'#E60000c3'}
            viewBox={`0 0 ${width} ${80}`}
          >
            <Rect x="0" y="0" rx="5" ry="5" width={width - 32} height={80} />
          </ContentLoader>} */}
            {recommandationError && <ErrorHandlerComponent
              textButton={'roaming_get_recommandation_error'}
              onRetry={() => getAndSetRecommandation(countryOnLocation?.name || null)}
            />}
            {!recommandationError && <OfferCard
              title={recommandation?.title}
              description={recommandation?.description}
              image={countryOnLocation?.image}
              withButton={false}
              recommandationLoading={recommandationLoading}
              buttonTitle={recommandation?.CTATitle}
              onPress={() => {
                if (recommandation?.CTAType?.includes('webview')) {
                  navigate('WebView', { url: recommandation?.CTAUrl, title: recommandation?.title, isReact: true })
                }
                else if (recommandation?.CTAType?.includes('deeplink')) {
                  navigate('Catalogue', { bundleId: recommandation?.myOfferId })
                }
                else {
                  setShowRecommandationMoreInfo(true)
                }
              }}
              theme={theme}
            />}

            <QuickActionMenu isVisible={showRecommandationMoreInfo} title={'roaming_more_info'} titleStyle={{ fontSize: 24, marginHorizontal: -15 }} withCloseButton type={'secondary'} closeModal={() => setShowRecommandationMoreInfo(false)} >
              <VFText i18nKey={recommandation?.longDesc} style={{ fontSize: 18, lineHeight: 24, marginVertical: 20 }} />
              <VFButton title='roaming_close' onPress={() => setShowRecommandationMoreInfo(false)} />
            </QuickActionMenu>
          </>

          {/* Suggested Bundles */}
          {bundles?.length > 0 && < VFText i18nKey={'roaming_bundles_title'} style={styles.boldTitle(theme)} />}
          {bundlesLoading && <View style={{ marginTop: 20 }}>
            {LOADING_BUNDLES.map(() => <Button bundlesLoading={true} />)}
          </View>}
          {bundlesError && <ErrorHandlerComponent
            textButton={'roaming_bundles_default_error'}
            onRetry={() => getAndSetBundles(countryOnLocation?.name || null)}
          />}
          {isArray(bundles) && bundles?.map(bundle => {
            return (
              <Button
                bundlesLoading={false}
                title={bundle?.title}
                price={bundle?.price}
                icon={Images.airplane}
                directionIcon={Images.rightArrowRed}
                onPress={() => navigate('Catalogue', {
                  bundleCategory: 'roaming',
                  bundleId: bundle.id
                })}
                theme={theme}
              />
            )
          })}
        </View>
      </ScrollView>
    </VFScreen>
  )
}

Home.defaultProps = {}

Home.propTypes = {}

export default Home
